// Icon size and color tokens
import { sizes } from '../../theme/tokens/sizes';
import { colors } from '../../theme/tokens/colors';

export const ICON_SIZES = {
    xs: sizes.icon.xs,  // 12px
    s: sizes.icon.s,    // 16px
    m: sizes.icon.m,    // 20px
    l: sizes.icon.l,    // 24px
    xl: sizes.icon.xl,  // 32px
} as const;

export const ICON_TONES = {
    black: colors.black,
    white: colors.white,
    yellow: colors.accentYellow,
    lightGrey: colors.lightGrey,
    darkGrey: colors.darkGrey,
    inherit: 'inherit',
} as const;

export type IconSize = keyof typeof ICON_SIZES;
export type IconTone = keyof typeof ICON_TONES;
